import React, {
  createContext,
  useContext,
  useMemo,
} from 'react';

const VehicleContext = createContext();

export const useVehicle = () => useContext(VehicleContext);

const VehicleContextProvider = ({
  vehicle,
  children,
  disableLinkOnSold = false,
  vdp,
}) => {
  if (!vdp) {
    console.trace();
    throw new Error('Missing vdp in vehicle');
  }
  if (!vdp.slugPrefix) {
    console.trace();
    throw new Error('Missing slugPrefix in vdp in vehicle context, did you forget to query it?');
  }
  if (!vdp.vdpType) {
    console.trace();
    throw new Error('Missing vdpType in vdp in vehicle context, did you forget to query it?');
  }

  const accessoriesWithImages = vehicle.images?.reduce((acc, { accessories }, index) => {
    const total = accessories?.reduce((subAcc, accessory) => ({
      ...subAcc,
      [accessory.id]: index,
    }), acc) || {};
    return total;
  }, {}) || {};
  const imagesAddedOnAccessories = vehicle.accessories?.map((accessory) => {
    const clickOpenImage = accessoriesWithImages[accessory.id];
    if (clickOpenImage) {
      return {
        ...accessory,
        clickOpenImage,
      };
    }
    return accessory;
  });

  const value = useMemo(() => ({
    ...vehicle,
    vdp,
    disableLinkOnSold,
    slug: `${vdp.slugPrefix}${vehicle.slug}`,
    formSlug: vdp.formPagePath ? `${vdp.slugPrefix}${vdp.formPagePath}${vehicle.slug}` : null,
    externalLease: vehicle.externalLeases?.find(
      // multiple external lease results are possbile, find the one requested for this vdp
      ({ vdp: { documentId, strapiId } }) => (
        documentId && vdp.documentId && (documentId === vdp.documentId)
      ) || String(strapiId) === String(vdp.strapiId),
    ),
    accessories: imagesAddedOnAccessories,
  }), [
    vehicle,
    vdp,
    disableLinkOnSold,
    imagesAddedOnAccessories,
  ]);

  return (
    <VehicleContext.Provider value={value}>
      {children}
    </VehicleContext.Provider>
  );
};

export default VehicleContextProvider;
